import { AppealMethodsComponent } from './appeal.methods.component'
import { BannerComponent } from './banner.component'
import { DailyStatisticsBlockComponent } from './daily.statistics.block.component'
import { ProcessStepsComponent } from './process.steps.component'
import { QuestionsListComponent } from './questions.list.component'
	
export const HomePage: React.FC = () => {
	return (
		<div style={{paddingTop: "140px"}}>	
		<BannerComponent />
		<DailyStatisticsBlockComponent/>
		<ProcessStepsComponent />
		<QuestionsListComponent />
		<AppealMethodsComponent />
		</div>
	)
}
